import axios from "./_axios";
import { API } from "./apiEndPoints";
import { createLatestRequestGuard } from "@components/utils/createLatestRequestGuard";

// ER-11705: one Organization page view reads GET account/{id}/ from the route
// guard, the page and the positions table (through getAvailableApps and
// getAccountData). Share a single request, and its response for a few seconds,
// so a page view hits the endpoint once. updateDirectory drops the cache, and
// reads that follow a write elsewhere (readiness reload/polling) pass `fresh`.
const ACCOUNT_DETAILS_TTL_MS = 5000;
const accountDetailsGuard = createLatestRequestGuard({ ttlMs: ACCOUNT_DETAILS_TTL_MS });

function cloneResponse(response) {
  if (response && typeof response === "object" && response.data != null) {
    return { ...response, data: JSON.parse(JSON.stringify(response.data)) };
  }
  return response;
}

export const fetchAccountDetails = async (account_id, { fresh = false } = {}) => {
  const response = await accountDetailsGuard.start(
    `account:${account_id}`,
    () =>
      axios()({
        method: "get",
        url: `${API.ACCOUNTList}${account_id}/`,
      }),
    { fresh }
  ).promise;
  return cloneResponse(response);
};

export const invalidateAccountDetails = () => {
  accountDetailsGuard.reset();
};

// ER-12785: queue the account-wide IQ scan of the saved company websites (owners and co-owners).
export const scanCompanyWebsitesNow = async (account_id) => {
  try {
    return await axios()({
      method: "post",
      url: `${API.ACCOUNT_LIST_V2}${account_id}/${API.COMPANY_WEBSITES_SCAN_NOW}`,
    });
  } finally {
    invalidateAccountDetails();
  }
};

export const getAvailableApps = async (account_id) => {
  return fetchAccountDetails(account_id);
};
export const updateDirectory = async (account_id, payload) => {
  try {
    return await axios()({
      method: "patch",
      url: `${API.ACCOUNTList}${account_id}/`,
      data: payload,
    });
  } finally {
    invalidateAccountDetails();
  }
};
